import "./ProjectSection.scss";
import { baseUrl } from "../../../utils/apiData";
import { motion } from "framer-motion";
import { images } from "../../../utils/images";

const ProjectSection = ({ data }) => {
  const title = data?.construction_heading;

  return (
    <section className="project_section p_t p_b">
       <img src={images.pattern} alt="Pattern" className="pattern_right" />
       <img src={images.pattern} alt="Pattern" className="pattern_left" />
      <div className="content_wrap">
        <h2 className="my_auto gold">
          {title
            ?.split("")
            .map((char, k) => (
              <motion.span
                initial={{ translateX: 24, opacity: 0 }}
                whileInView={{ translateX: 0, opacity: 1 }}
                transition={{
                  duration: 0.3,
                  ease: "easeInOut",
                  delay: 0.04 * k,
                }}
                key={k}
              >
                {char}
              </motion.span>
            ))
            .concat("")}
        </h2>
        <p className="my_auto gold">{data?.construction_description}</p>

        <div className="img_view">
          <div className="img_wrap left">
            <img src={`${baseUrl}/${data?.amenties?.[0]}`} alt="project" />
          </div>
          <div className="img_wrap center">
            <img src={`${baseUrl}/${data?.amenties?.[1]}`} alt="project" />
          </div>
          <div className="img_wrap right">
            <img src={`${baseUrl}/${data.amenties?.[2]}`} alt="project" />
          </div>
        </div>
      </div>
      <div className="white_strip"></div>
    </section>
  );
};

export default ProjectSection;
